import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { manifestStagedShipmentResponse } from '../../core/api/lab.types';

/* Create new CryoBox */
export const manifestStagedShipmentThunk = createAsyncThunk(
  'shipment/manifestStagedShipment',
  async (_, { rejectWithValue }: any) => {
    const response: manifestStagedShipmentResponse = await labApi.manifestStagedShipment();
    if (response.data?.manifestStagedShipment) {
      return response.data?.manifestStagedShipment;
    }
    return rejectWithValue(response.errors);
  },
);
